@let schools = schools$ | async; @let mapOptions = mapOptions$ | async;

<red-header-content>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="{{defaultBackHref}}/profile/{{profileId}}"></ion-back-button>
    </ion-buttons>
    <ion-title>Schools</ion-title>
  </ion-toolbar>
</red-header-content>
<ion-content color="light" [scrollX]="false" [scrollY]="false">
  <red-fluid-layout>
    <ng-container content>
      @if (mapOptions) { @let profileLocation = profileLocation$ | async; @let markerOptions = markerOptions$ | async;

      <google-map height="100%" width="100%" [options]="mapOptions" (mapInitialized)="mapInitialized($event)">
        <red-user-position></red-user-position>
        @if (profileLocation && markerOptions) {
        <map-marker [position]="profileLocation" [options]="markerOptions"></map-marker>
        } @let schoolMakers = schoolMarkers$ | async; @for (marker of schoolMakers; track schoolTrackBy($index)) {
        <map-marker [position]="marker.position" [options]="marker.options"></map-marker>
        }
      </google-map>
      }
      <div class="tw:absolute tw:top-0 tw:w-full">
        <red-map-default-options>
          <ion-fab-button (click)="centerOnBounds()" color="light" size="small">
            <ion-icon src="/assets/svg/target.svg"></ion-icon>
          </ion-fab-button>
        </red-map-default-options>
      </div>
    </ng-container>

    <ion-list [inset]="false" sidebar>
      @for (school of schools; track schoolTrackBy(schoolPosition); let schoolPosition = $index; let isLastElement =
      $last) {
      <ion-item
        [button]="true"
        [lines]="isLastElement ? 'none' : 'full'"
        routerLink="{{defaultBackHref}}/profile/{{profileId}}/schools/{{schoolPosition + 1}}"
      >
        <ion-note
          slot="start"
          color="dark"
          class="tw:text-center tw:text-3xl tw:font-bold"
          [ngClass]="{'tw:w-12': schoolPosition + 1 < 1000}"
        >
          {{school.markerId}}
        </ion-note>
        <ion-label>
          <ion-text color="primary" class="tw:text-md tw:font-bold"> {{school.data.SchoolName | titlecase}} </ion-text>
          <br />
          <ion-text color="medium" class="tw:text-sm">
            {{school.data | redAddress:addressType.LineOneAndCity}}
          </ion-text>
          <br />
          <ion-text class="tw:text-sm">{{school.data.Distance}} miles away</ion-text>
        </ion-label>
      </ion-item>
      }
    </ion-list>
  </red-fluid-layout>
</ion-content>
